import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-start-time-error__container" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-alert-60px" }, null, -1);
const _hoisted_3 = { class: "modal-start-time-error__text" };
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalStartTimeError',
    setup(__props) {
        const store = useStore();
        const isVisible = computed({
            get: () => store.state.audienceManager.modal?.startTimeError || false,
            set: (value) => {
                store.commit('audienceManager/UPDATE_VISIBILITY_INTEGRATION_MODAL', {
                    type: 'startTimeError',
                    value,
                });
            },
        });
        const closeModal = () => {
            isVisible.value = false;
        };
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: isVisible.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isVisible).value = $event)),
                class: "modal-start-time-error",
                "append-to-body": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('audiences.start-time-error-modal.text')), 1),
                        _createElementVNode("button", {
                            class: "btn",
                            onClick: closeModal
                        }, _toDisplayString(_ctx.$t('audiences.start-time-error-modal.button')), 1)
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
